<template>
  <div>
    <el-dialog
      title="资源资产流转审批"
      :visible.sync="dialogVisible"
      width="90%"
      center
      :before-close="handleClose"
    >
      <!-- 项目详情 -->
      <div class="project-detail">
        <div class="define-table">
          <table style="table-layout: fixed; border: 1px">
            <tr>
              <td rowspan="3">申请人基本情况</td>
              <td>单位名称</td>
              <td>{{ projectInfo.lrf ? projectInfo.lrf : "" }}</td>
              <td>统一社会信用代码</td>
              <td colspan="3">{{ projectInfo.socialCreditId ? projectInfo.socialCreditId : "" }}</td>
            </tr>
            <tr>
              <td>自然人（法定代表人）</td>
              <td>
                {{ projectInfo.lrfBossName ? projectInfo.lrfBossName : "" }}
              </td>
              <td>身份证号码</td>
              <td colspan="3">{{ projectInfo.lrfIdCard ? projectInfo.lrfIdCard : "" }}</td>
            </tr>
            <tr>
              <td>联系电话</td>
              <td>{{ projectInfo.lrfPhone ? projectInfo.lrfPhone : "" }}</td>
              <td>联系地址</td>
              <td colspan="3">{{ projectInfo.contactAddress ? projectInfo.contactAddress : "" }}</td>
            </tr>

            <tr>
              <td rowspan="4">拟流转土地的基本情况</td>
              <td>土地位置</td>
              <td colspan="5">{{ projectInfo.landLocation ? projectInfo.landLocation.join('与') : "" }}</td>
            </tr>
            <tr>
              <td>土地规模</td>
              <td colspan="5">{{ landScaleData }}</td>
            </tr>
            <tr>
              <td>土地用途</td>
              <td colspan="5">{{ projectInfo.landPurpose }}</td>
            </tr>
            <tr>
              <td>流转年限</td>
              <td colspan="5">{{ projectInfo.transferYear }}</td>
            </tr>
          </table>
        </div>
      </div>


      <div class="project-detail">
        <div
          class="list-container"
          v-for="(item, index) in projectInfo.lcfList"
          :key="index"
        >
          <div class="list-item">

            <div class="list-row">
              <div class="list-col">
                <span class="asset-link" @click.stop="viewAssetDetail(item)">{{ item.xmmc || "" }}</span>
              </div>
            </div>
            <div class="vertical-layout">
              <!-- 流转意向书 -->
              <div class="document-section">
                <h4 class="doc-title">流转意向书</h4>
                <div class="horizontal-image-container">
                  <div class="image-grid">
                    <el-image
                      v-for="(img, idx) in item.intentionImages"
                      :key="idx"
                      :src="img"
                      :preview-src-list="item.intentionImages"
                      class="compact-image"
                    />
                  </div>
                </div>
              </div>

              <!-- 委托流转书面委托书 -->
              <div class="document-section">
                <h4 class="doc-title">委托流转书面委托书</h4>
                <div class="horizontal-image-container">
                  <div class="image-grid">
                    <el-image
                      v-for="(img, idx) in item.entrustImages"
                      :key="idx"
                      :src="img"
                      :preview-src-list="item.entrustImages"
                      class="compact-image"
                    />
                  </div>
                </div>
              </div>

              <!-- 集体经济组织成员大会会议纪要 -->
              <div class="document-section">
                <h4 class="doc-title">集体经济组织成员大会会议纪要</h4>
                <div class="horizontal-image-container">
                  <div class="image-grid">
                    <el-image
                      v-for="(img, idx) in item.meetingImages"
                      :key="idx"
                      :src="img"
                      :preview-src-list="item.meetingImages"
                      class="compact-image"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div><span>其他文件</span></div>
        <div class="other-files-section">
          <div v-for="(section, index) in otherFilesList" :key="index" class="file-category">
            <h4>{{ section.title }}</h4>
            <div class="image-grid">
              <el-image
                v-for="(img, idx) in section.images"
                :key="idx"
                :src="img"
                :preview-src-list="section.images"
                class="preview-image"
              />
            </div>
          </div>
        </div>
      </div>

      <div class="bottomBtn" v-if="transact">
        <button class="backBtn" @click="tuihui">退回</button>
        <button class="submitBtn" @click="tongyi">符合规定，同意流转</button>
      </div>
    </el-dialog>
    <!-- 查看合同弹窗 -->
    <el-dialog
      title="查看合同"
      :visible.sync="HTVisible"
      width="50%"

      append-to-body
      :before-close="handleClose"
    >
      <!-- 展示上传的图片 -->
      <div>
        <div class="tabs">
          <div v-for="(item, index) in tabList" :key="index">
            <span @click="detailBtn(index)">{{ item.title }}</span>
          </div>
          <!-- <div v-for="(item,index) in 5" :key="index">
            {{ index }}
          </div> -->
        </div>
        <div class="ShowList" v-if="fileList.length">
          <div class="innerTable" style="display: flex">
            <div
              v-for="(file, index) in fileList"
              :key="index"
              style="
                display: flex;
                /* flex-direction: column; */
                align-items: center;
                padding: 10px;
              "
            >
              <!-- <span>{{ file.FilesName }}</span> -->
              <el-image
                ref="preview"
                style="width: 115px; height: 115px"
                class="el-upload-list__item-thumbnail"
                :src="file.imgUrl ? file.imgUrl : file"
                :preview-src-list="innerTableList"
                alt="图片无法加载"
                :initial-index="index"
              />
            </div>
          </div>
        </div>
        <div v-else style="width: 100%; text-align: center">暂无数据</div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="HTVisible = false">关 闭</el-button>
        <!-- <el-button type="primary" @click="HTVisible = false">确 定</el-button> -->
      </span>
    </el-dialog>

    <el-dialog
      title="审批不通过"
      :visible.sync="onshow"
      width="30%"
      append-to-body
    >
      <!-- 展示上传的图片 -->
      <div class="tuihui">
        <div class="leftbox">退回说明</div>
        <div class="rightbox">
          <el-input
            type="textarea"
            :rows="8"
            placeholder="请输入内容"
            v-model="title"
          >
          </el-input>
        </div>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="onshow = false">取 消</el-button>
        <el-button type="primary" @click="reject">退 回</el-button>
      </span>
    </el-dialog>

    <el-dialog
      title="审批通过"
      :visible.sync="showy"
      width="20%"
      append-to-body
    >
      <!-- 展示上传的图片 -->
      <div class="tongyi">
        <div class="topbox">
          <span>审批意见：</span>
          <el-input type="textarea" :rows="8" v-model="idea" @input="callApiOnBlur" ></el-input>
        </div>
        <!-- <div class="footerbox">
          <div v-if="showy" class="img">
            <vue-qr
              ref="qrCode"
              :text="text"
              :logoSrc="logoSrc"
              :color-dark="randomColor"
              :callback="qrCodeCallback"
              width="200"
              height="200"
            ></vue-qr>
          </div> -->
          <!-- <el-button type="primary" @click="regenerateQRCode()">
              重新生成
            </el-button> -->

          <!-- <img src="../../../assets/acquiesce.png" alt="加载失败" /> -->
          <!-- <h1 style="color: #ccc">请使用微信扫描后签字提交</h1>
        </div> -->
      </div>
      <span slot="footer">
        <el-button type="primary" @click="showy = false">取 消</el-button>
        <el-button type="primary" @click="confirmTongyi">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import {
  selectCirculationApproval,
  rejectWorkflow,
  selectBackUpContract,
  selectApprovalOtherMaterials,
  completeWorkflow
} from "@/api/spgl";
// import { log } from "console";
import { getLzlx, getCqlx } from "../../../util/types";
// import { title } from "process";
//数据总线
import { Utils } from "@/assets/js/util.js";
import VueQr from "vue-qr";
const baseUrl = window.globalUrl.HOME_API;
const Url = window.globalUrl.api;
export default {
  data() {
    return {
      text: window.globalUrl.api,
      logoSrc: "",
      randomColor: "black",
      qrCodeUrl: "", // 存放生成的二维码url
      isValid: true, // 添加一个状态来跟踪二维码是否有效
      taskId: "", // 查询id
      identityId: "", // 身份id identityObj.content.identityId;

      dataobj: {}, // 存放详情数据
      tabList: [
        {
          title: "查看合同",
          index: "1",
        },
        {
          title: "其他附件",
          index: "2",
        },
      ],
      time: "",
      time1: "",
      title: "", // 审批退回不通过陈述
      idea: "符合规定，同意流转", // 审批通过意见
      dialogVisible: true,
      onshow: false, // 退回弹窗
      showy: false, // 同意弹窗
      projectInfo: {}, // 详情信息
      // checkList: ["选中且禁用", "复选框 A"],
      HTVisible: false,
      baseUrl: window.globalUrl.BASE_API,
      fileList: [],
      innerTableList: [],
      transact: false,
      HTVlist: {},
      landScaleData: "",  //土地规模
      otherFilesList: []
    };
  },
  components: {
    VueQr,
  },
  computed: mapGetters(["userInfo", "access_token", "identityObj"]),
  created() {
    var that = this;
    Utils.$off("dbspDetails");
    Utils.$on("dbspDetails", function (e) {
      console.log("44454", e.data);
      console.log(JSON.parse(e.data));
      let res = JSON.parse(e.data);
      if (res.content == "已收到审批进程结束") {
        that.showy = false;
        that.handleClose();
      }
      // that.updateChat(e);
    });
  },
  methods: {
    async detailBtn(index) {
      console.log(index);
      this.innerTableList = [];
      this.fileList = [];
      if (index == 0) {
        this.showFile();
      } else if (index == 1) {
        this.showPic();
      }
    },
    // 查看合同
    async HTVisibleFn(item) {
      this.HTVisible = true;
      this.HTVlist = item;
      this.showFile();
    },

    // 查看文件
    async showFile(item) {
      let res = await selectBackUpContract({
        approvalId: this.HTVlist.approvalId,
        xmbh: this.HTVlist.xmbh,
        // approvalId: '20245117220001',
        // xmbh: 'CYC202310160152',
      });
      res = res.data ? JSON.parse(res.data.contractPicUrl) : {};
      this.fileList = res.map((item) => {
        return {
          ...item,
          imgUrl: `${baseUrl}/admin/file/get?ossFilePath=${item.imgUrl}`,
        };
      });
      this.innerTableList = this.fileList.map((item) => {
        return `${baseUrl}/admin/file/get?ossFilePath=${item.imgUrl}`;
      });
    },

    // 查看照片
    async showPic(item) {
      let res = await selectApprovalOtherMaterials({
        approvalId: this.HTVlist.approvalId,
        xmbh: this.HTVlist.xmbh,
      });

      const otherMaterials = res.data.otherFiles.split(",").map(url => url.trim());
      console.log("455555",otherMaterials);

      this.fileList = otherMaterials.map((item) => {
        return {
          imgUrl: `${baseUrl}/admin/file/get?ossFilePath=${item}`,
        };
      });
      this.innerTableList = otherMaterials.map((item) => {
        return `${baseUrl}/admin/file/get?ossFilePath=${item}`;
      });
      console.log(this.innerTableList);
    },
    webSocketOnOpen(e) {
      console.log("与服务端连接打开->", e);
      if (this.webSocketObject.readyState == this.webSocketObject.CONNECTING) {
        console.log("连接正在打开");
      }
      if (this.webSocketObject.readyState == this.webSocketObject.OPEN) {
        console.log("连接已打开");
      }
      //开启心跳
      // this.start();
    },
    // 消息监听
    webSocketOnMessage(e) {
      if (JSON.parse(e.data).type == "agreeProcess") {
        console.log("这是最新的消息", e);
        // this.updateChat(e);
      }
    },

    callApiOnBlur() {
      let identityObj = JSON.parse(localStorage.getItem("identityObj"));
      // console.log("identityObj", identityObj.content.identityId);
      this.identityId = identityObj.content.identityId;
      this.text = `${Url}?taskId=${this.taskId}/processInstanceId=${this.dataobj.instanceProcessId}/agreeReason=${this.idea}/identityId=${this.identityId}`;
    },
    // resetQRCodeStatus() {
    //   setTimeout(() => {
    //     this.isValid = false; // 将 isValid 设置为有效
    //     console.log("二维码状态已恢复为有效");
    //   }, 100); // 1秒后恢复有效状态
    // },
    // 处理二维码回调，设置二维码的URL
    qrCodeCallback(url) {
      this.qrCodeUrl = url;
    },
    regenerateQRCode() {
      this.isValid = false; // 设置状态为有效
    },

    // 拒绝
    async reject(row) {
      let res = await rejectWorkflow({
        processInstanceId: this.dataobj.instanceProcessId,
        rejectReason: this.title,
        taskId: this.taskId,
      });
      console.log(res);
      if (res.code == 0) {
        this.title = "";
        this.onshow = false;
        this.$message.success("退回成功");
        this.handleClose();
        // this.resetQRCodeStatus(); // 重置二维码状态
      } else {
        this.$message.error("退回失败");
      }
    },
    // 接收参数
    receiveData(data, Boolean) {
      let identityObj = JSON.parse(localStorage.getItem("identityObj"));
      console.log("identityObj", identityObj.content.identityId);
      this.identityId = identityObj.content.identityId;
      this.taskId = data.taskId;
      this.dataobj = data;
      this.transact = Boolean;
      this.text = `${Url}?taskId=${this.taskId}/processInstanceId=${this.dataobj.instanceProcessId}/agreeReason=${this.idea}/identityId=${this.identityId}`;
      this.details();
      console.log("4444444444444444444", data);
    },
    // 详情
    async details() {
      let res = await selectCirculationApproval({
        taskId: this.taskId,
        // taskId: "d5dd5c6e-50a3-11ef-b412-005056c00008",
      });
      this.projectInfo = res.data ? res.data : {};

      //处理一下数据
      if (this.projectInfo.landScale) {
        console.log(this.projectInfo.landScale, '拼接土地规模');
        const landTypeMap = this.projectInfo.landScale.landTypeMap;
        const addressList = this.projectInfo.landScale.addressList || [];

        const landTypeStr = Object.entries(landTypeMap).map(([type, areas]) => {
          const sum = Object.values(areas).reduce((a, b) => a + b, 0);
          const areaDetails = Object.entries(areas).map(([area, mu]) => `${area}${mu}亩`).join('、');
          return `${type}${sum}亩（${areaDetails}）`;
        }).join('、');

        console.log(landTypeStr, '拼接好');
        this.landScaleData = `合计${this.projectInfo.sumArea}亩（${addressList.join('、')}）其中：${landTypeStr}`;
      }

      if (this.projectInfo.lcfList && this.projectInfo.lcfList.length > 0) {
        this.projectInfo.lcfList.forEach(item => {
          console.log("item数据", item);
          // 转换意向书图片
          if(item.transferIntentionAgreement && JSON.parse(item.transferIntentionAgreement).length > 0)
          item.intentionImages = (JSON.parse(item.transferIntentionAgreement) || []).map(file =>
            `${baseUrl}/admin/file/get?ossFilePath=${file.url}`
          );

          // 转换委托书图片
          if(item.transferEntrustment && JSON.parse(item.transferEntrustment).length > 0) {
            item.entrustImages = (JSON.parse(item.transferEntrustment) || []).map(file =>
              `${baseUrl}/admin/file/get?ossFilePath=${file.url}`
            );
          }


          // 转换会议纪要图片
          if(item.meetingMinutes && JSON.parse(item.meetingMinutes).length > 0) {
            item.meetingImages = (JSON.parse(item.meetingMinutes) || []).map(file =>
              `${baseUrl}/admin/file/get?ossFilePath=${file.url}`
            );

          }
        });
      }
      console.log("this.projectInfo", this.projectInfo);
      //其他文件也需要做下处理

      if (this.projectInfo.otherFile) {
        this.otherFilesList = [
          {
            title: '营业执照或法人资格证明，自然人有效身份证明',
            images: [
              ...this.getFileUrls('qualificationCertificate'),
              ...this.getFileUrls('proofOfIdentity')
            ]
          },
          {
            title: '资信证明和信用报告，自然人个人信用报告',
            images: this.getFileUrls('creditReport')
          },
          {
            title: '章程或合伙人协议',
            images: this.getFileUrls('partnerAgreement')
          },
          {
            title: '农业经营项目规划书',
            images: this.getFileUrls('projectPlan')
          },
          {
            title: '农业经营能力或资质的证明',
            images: this.getFileUrls('operationCapacity')
          }
        ];
      }

    },

    getFileUrls(field) {
      // 修正字段访问方式，添加多层空值保护
      const fieldData = ((this.projectInfo.otherFile || {})[field] || '[]');
      try {
        return (JSON.parse(fieldData) || [])
          .map(file => `${baseUrl}/admin/file/get?ossFilePath=${file.url}`);
      } catch (e) {
        console.error('JSON解析失败:', e);
        return [];
      }
    },

    viewAssetDetail(item) {
      this.$router.push({ name: "projectDetail", query: { c: item.xmbh } });
    },
    lzlx(type) {
      let res = getLzlx(type);
      return res;
    },
    cqlx(type) {
      console.log("type", type);
      let list = JSON.parse(localStorage.getItem("types"));
      let res = "";
      console.log(list);
      if (list && list.length > 0) {
        let res = getCqlx(type, list);
        console.log(res);
        return res;
      } else {
        return "";
      }
    },

    handleClose() {
      this.$emit("closeDialog", false);
    },

    // 退回
    tuihui() {
      this.onshow = true;
    },
    // 同意
    tongyi() {
      let identityObj = JSON.parse(localStorage.getItem("identityObj"));
      console.log("identityObj", identityObj.content.identityId);
      this.identityId = identityObj.content.identityId;
      this.showy = true;
      // this.text = `${Url}?taskId=${this.taskId}/processInstanceId=${this.dataobj.instanceProcessId}/agreeReason=${this.idea}/identityId=${this.identityId}`;
      // console.log("同意", this.text);
    },

    // 确认同意
    async confirmTongyi() {
      let res = await completeWorkflow({
        processInstanceId: this.dataobj.instanceProcessId,
        agreeReason: this.idea,
        taskId: this.taskId,
      });
      console.log(res, 'tongyiliuzhuan');
      if (res.code == 0) {
        this.idea = "符合规定，同意流转";
        this.$message.success(res.msg);
        this.showy = false;
        this.handleClose();
        // this.resetQRCodeStatus(); // 重置二维码状态
      } else {
        this.$message.error(res.mag);
        this.showy = false;
      }
    },

    // 关闭弹框
    closeDialog() {
      this.isShow = false;
    },
    // 切换时间
    changeTime(val) {
      console.log(val);
      // if (val == 1) {
      this.startTime = val;
      // } else {
      //   this.endTime = val[1];
      // }
    },
    // 切换时间
    changeTime1(val) {
      console.log(val);
      // if (val == 1) {
      //   this.startTime = val[0];
      // } else {
      this.endTime = val;
      // }
    },
  },
};
</script>
<style lang="less" scoped>
.tongyi {
  box-sizing: border-box;
  .topbox {
    span {
      width: 30%;
      font-size: 20px;
      // font-weight: 400;
      color: #000;
    }
    input {
      width: 60%;
      font-size: 20px;
    }
  }

  .footerbox {
    width: 100%;
    text-align: center;
    margin-top: 20px;
    .img {
      width: 100%;
      height: 100%;
    }
  }
}
.tuihui {
  display: flex;
  box-sizing: border-box;
  width: 100%;
  border: 1px solid #000;
  .leftbox {
    width: 20%;
    height: 200px;
    text-align: center;
    line-height: 200px;
    font-size: 20px;
    border-right: 1px solid #000;
  }
  .rightbox {
    width: 80%;
    height: 200px;

    // border-right: 1px solid #000;
  }
}
.project-detail {
  width: 1200px;
  max-height: 400px;  // 设置最大高度
  overflow-y: auto;
  margin: 0 auto;
  background: #fff;
  text-align: left;
  padding-bottom: 50px;

  .define-tableDetails {
    margin-top: 50rpx;
  }
  table {
    width: 100%;

    border-collapse: collapse; /* 合并线段 */
  }

  th,
  td {
    border: 1px solid black;
    padding: 8px;
    text-align: left;
    text-align: center;
  }

  th {
    background-color: #f2f2f2;
  }
  .tableTop {
    padding-top: 10px;
  }
}
.bottomBtn {
  width: 100%;
  display: flex;
  justify-content: flex-end;
  .backBtn {
    width: 100px;
    height: 40px;
    color: #fff;
    background: #f7c6cc;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 50px;
  }
  .submitBtn {
    width: 150px;
    height: 40px;
    display: flex;
    color: #fff;
    margin-left: 20px;
    justify-content: center;
    align-items: center;
    background: #02a7f0;
    border-radius: 50px;
  }
}
.tabs {
  width: 100%;
  height: 100rpx;
  display: flex;
  margin: 20px 0px;

  span {
    margin-right: 20px;
    border: solid 2px #ccc;
    padding: 5px 5px;
    cursor: pointer;
  }
}
.ShowList {
  width: 100%;

  table {
    width: 100%;
    border-collapse: collapse;
    text-align: center;
    tr {
      td {
        .box {
          width: 150px;
          height: 100px;
          overflow: hidden;
          padding: 5px 5px;
          .Imgs {
            width: 232px;
            .el-image {
              margin-right: 5px;
            }
          }
        }
      }
    }
  }
}

.list-container {
  margin-bottom: 20px;
  border: 1px solid #ebeef5;
  border-radius: 4px;
  padding: 15px;

  .list-item {
    .list-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 15px;
      padding-bottom: 10px;
      border-bottom: 1px solid #eee;

      .title {
        font-weight: 600;
        color: #303133;
      }
      .contract {
        color: #169bd5;
        cursor: pointer;
        &:hover {
          text-decoration: underline;
        }
      }
    }

    .list-row {
      display: flex;
      flex-wrap: wrap;
      margin-bottom: 10px;

      .list-col {
        flex: 0 0 33.33%;
        padding: 8px 10px;
        display: flex;
        align-items: center;

        label {
          color: #909399;
          min-width: 80px;
          margin-right: 10px;
        }
        span {
          color: #606266;
        }
      }
    }
  }
}

.button-group {
  display: flex;
  gap: 15px;
}
.view-detail {
  color: #67C23A;
  cursor: pointer;
  &:hover {
    text-decoration: underline;
  }
}
.vertical-layout {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.document-section {
  display: flex;
  align-items: flex-start;
  // margin-bottom: 5px;

  .doc-title {
    width: 200px;
    min-width: 200px;
    font-size: 14px;
    color: #666;
    margin-right: 20px;
    padding-top: 5px;
  }

  .horizontal-image-container {
    flex-grow: 1;
    overflow-x: auto;
  }
}

.image-grid {
  display: flex;
  gap: 10px;
  padding: 8px 0;

  .compact-image {
    width: 50px;
    height: 50px;
    min-width: 50px;
    border: 1px solid #eee;
    border-radius: 4px;
  }
}

.asset-link {
  color: #409eff; /* 使用element主题色 */
  cursor: pointer;
  transition: color 0.3s ease;
  text-decoration: none;
  font-weight: bold;

  &:hover {
    color: #66b1ff; /* 悬停颜色 */
    text-decoration: underline;
  }

  &:active {
    color: #3a8ee6; /* 点击状态 */
  }
}
.other-files-section {
  margin-top: 20px;
  .file-category {
    margin-bottom: 30px;
    h4 {
      font-size: 14px;
      color: #333;
      margin: 15px 0;
      padding-left: 10px;
      border-left: 4px solid #409EFF;
    }
  }
}
.preview-image {
  width: 50px;
  height: 50px;
  border: 1px solid #eee;
  border-radius: 4px;
  margin-right: 10px;
}
</style>
